import apiClient from '../lib/apiClient';

// Company Details
const getCompanyDetails = async () => {
  try {
    const result = await apiClient.get('/settings/company');
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to fetch company details' };
  }
};

const updateCompanyDetails = async (data) => {
  try {
    const result = await apiClient.put('/settings/company', data);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to update company details' };
  }
};

// Telecallers Master
const getTelecallers = async () => {
  try {
    const result = await apiClient.get('/settings/telecallers');
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to fetch telecallers' };
  }
};

const createTelecaller = async (data) => {
  try {
    const result = await apiClient.post('/settings/telecallers', data);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to create telecaller' };
  }
};

const updateTelecaller = async (id, data) => {
  try {
    const result = await apiClient.put(`/settings/telecallers/${id}`, data);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to update telecaller' };
  }
};

const deleteTelecaller = async (id) => {
  try {
    const result = await apiClient.delete(`/settings/telecallers/${id}`);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to delete telecaller' };
  }
};

// Lead Sources Master
const getLeadSources = async () => {
  try {
    const result = await apiClient.get('/settings/lead-sources');
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to fetch lead sources' };
  }
};

const createLeadSource = async (data) => {
  try {
    const result = await apiClient.post('/settings/lead-sources', data);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to create lead source' };
  }
};

const updateLeadSource = async (id, data) => {
  try {
    const result = await apiClient.put(`/settings/lead-sources/${id}`, data);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to update lead source' };
  }
};

const deleteLeadSource = async (id) => {
  try {
    const result = await apiClient.delete(`/settings/lead-sources/${id}`);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to delete lead source' };
  }
};

// Skill Levels Master
const getSkillLevels = async () => {
  try {
    const result = await apiClient.get('/settings/skill-levels');
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to fetch skill levels' };
  }
};

const createSkillLevel = async (data) => {
  try {
    const result = await apiClient.post('/settings/skill-levels', data);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to create skill level' };
  }
};

const updateSkillLevel = async (id, data) => {
  try {
    const result = await apiClient.put(`/settings/skill-levels/${id}`, data);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to update skill level' };
  }
};

const deleteSkillLevel = async (id) => {
  try {
    const result = await apiClient.delete(`/settings/skill-levels/${id}`);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to delete skill level' };
  }
};

export default {
  getCompanyDetails,
  updateCompanyDetails,
  getTelecallers,
  createTelecaller,
  updateTelecaller,
  deleteTelecaller,
  getLeadSources,
  createLeadSource,
  updateLeadSource,
  deleteLeadSource,
  getSkillLevels,
  createSkillLevel,
  updateSkillLevel,
  deleteSkillLevel
};

